import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth from './reducers/auth';
import filter from './reducers/filter';
import billing from './reducers/billing';
import operator from './reducers/operator';
import sub from './reducers/sub';
import subs from './reducers/subs';
import unsubs from './reducers/unsubs';
import conversion from './reducers/conversion';
import campaigns from './reducers/campaigns';
import refunds from './reducers/refunds';
import timings from './reducers/timings';
import notification from './reducers/notification';
import users from './reducers/users';
import serviceManager from './reducers/serviceManager';
import dns from './reducers/dns';

export default combineReducers({
  routing: routerReducer,
  auth,
  filter,
  billing,
  sub,
  subs,
  unsubs,
  operator,
  conversion,
  campaigns,
  refunds,
  timings,
  notification,
  users,
  serviceManager,
  dns
})



// WEBPACK FOOTER //
// ./src/redux/reducer.js